import type {
	CampaignCardView,
	CampaignKpiStatus,
} from "../../../shared/types/campaign-card.type";

const STALE_STATUSES = new Set(["PAUSED", "BANNED", "REMOVED"]);

const KPI_STATUS_BANNERS: Partial<Record<CampaignKpiStatus, string>> = {
	not_applicable:
		"Кампанія прогріву (heartbeat): показники Profit, ROI, CPI і CPA не застосовуються",
	unclassified:
		"Тип кампанії не підтверджено: показники Profit, ROI, CPI і CPA можуть бути неточними",
};

type Props = {
	campaign: CampaignCardView;
};

export const CampaignBanners = ({ campaign }: Props) => {
	const isStale = STALE_STATUSES.has(campaign.status.toUpperCase());
	const kpiStatus = campaign.classification?.kpiStatus;
	const kpiBanner = kpiStatus ? KPI_STATUS_BANNERS[kpiStatus] : undefined;

	if (!isStale && !kpiBanner) return null;

	return (
		<>
			{isStale && (
				<div className='campaign-detail__banner campaign-detail__banner--warning'>
					Кампанія у статусі {campaign.status} — метрики Google Ads неактуальні
				</div>
			)}
			{kpiBanner && (
				<div className='campaign-detail__banner campaign-detail__banner--warning'>
					{kpiBanner}
				</div>
			)}
		</>
	);
};
